export default "__VITE_ASSET__CqQwYYex__"